import React, { useState, useEffect } from 'react';
import axios from 'axios';

// componentes
import Registro from './../../../Atendimento/Apolice/Registro';
import { Col, Row } from 'react-bootstrap';

function Apolices({ idCliente }) {

    // estados
    const [carregando, alterarCarregando] = useState(true);
    const [consulta, alterarConsulta] = useState([]);    

    // faz a consulta das apólices externas
    async function consultarApolices() {
        
        try {

            // consulta as apólices do cliente
            const { data } = await axios.get(`/clientes/apolice/${idCliente}`);
            alterarConsulta(data.fichas);
            alterarCarregando(false);

        } catch({ response }) {
            console.error(response);
        }

    }

    useEffect(() => {
        consultarApolices();
    }, []);

    if(carregando){
        return <p>Carregando...</p>
    }

    return <div>
        <br />
        <Row>
            <Col lg={{span: 6, offset: 3}}>
                {consulta.map(ficha =>
                    <Registro 
                        key={ficha.id}
                        dados={ficha}
                        extra={true}
                    />
                )}
            </Col>
        </Row>
    </div>


}

export default Apolices;